import {useEffect,useState} from 'react';
import {onAuthStateChanged} from 'firebase/auth';
import {doc,onSnapshot} from 'firebase/firestore';
import {auth,db} from '../../firebase';
import {salesAccess} from './salesModel';
export default function useSalesSession() {
 const [session,setSession]=useState(null);
 useEffect(()=>{
  let stop=[], generation=0;
  const off=onAuthStateChanged(auth,user=>{
   const current=++generation;stop.forEach(fn=>fn());stop=[];setSession(null);
   if(!user) return;
   let u,a;
   const refresh=()=>current===generation && setSession(salesAccess(u,a,user.uid)?{uid:user.uid,tenantId:a.tenantId}:null);
   stop=[onSnapshot(doc(db,'users',user.uid),s=>{u=s.data();refresh()},()=>{u=undefined;if(current===generation)setSession(null)}),onSnapshot(doc(db,'accessProfiles',user.uid),s=>{a=s.data();refresh()},()=>{a=undefined;if(current===generation)setSession(null)})];
  });return ()=>{generation++;off();stop.forEach(fn=>fn())};
 },[]);
 return session;
}
